import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';
import axFile from 'src/store/configFile';


const initialState = {
    servicesList: null,
    servicesListLoading: false
};

export const servicesAction = createAsyncThunk('servicesAction', async (payload, { dispatch }) => {
    dispatch(setServicesListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/services';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setServicesListLoading(false))
                return data

            case 'post':
                ({ data } = await axFile.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Услуга успешно отредактирована`
                })
                break;

            case 'put':
                ({ data } = await axFile.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Услуга успешно добавлена`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Услуга успешно удалена`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setServicesListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const ServicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        setServicesListLoading: (state, action) => {
            state.servicesListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(servicesAction.fulfilled, (state, action) => {
            state.servicesList = action.payload
        })
    }
});

export const { setServicesListLoading } = ServicesSlice.actions;

export default ServicesSlice.reducer